import { Box, CircularProgress, Grid, Skeleton } from '@mui/material';
import React from 'react';

export default function ReportLoadingComponent() {
    return (
        <Box
            display='grid'
            gridTemplateRows='repeat(auto-fill, minmax(20px, 30px))'
            height='100%'
        >
            {Array.from({ length: 30 }, (_, index) => (
                <Skeleton key={index} />
            ))}
        </Box>
    );
}
